import { mutatorAction } from 'satcheljs';
import { getAsyncItemRegistry } from '../selectors/getAsyncItemRegistry';
import type { AsyncItemEntry } from '../store/schema/AsyncItemEntry';

/**
 * Inserts (or overwrites) an async item entry in its account's registry, keyed by `entry.id`.
 * The registry must already exist (callers ensure it via `ensureAsyncItemRegistryMutator`)
 */
export const upsertAsyncItemEntryMutator: (entry: AsyncItemEntry) => void = mutatorAction(
    'upsertAsyncItemEntryMutator',
    (entry: AsyncItemEntry) => {
        const registry = getAsyncItemRegistry(entry.mailboxInfo);
        if (!registry) {
            return;
        }
        registry.entriesById.set(entry.id, entry);
    }
);
